'use client';

import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { ReactNode, useMemo } from 'react';

import { HELP_EMAIL } from '../../../[locale]/(partners)/business/const';

export interface HelpEmailLinkProps extends Omit<TypographyProps, 'children'> {
  readonly standalone?: boolean;
  readonly helpEmail?: string;
}

const HelpEmailLink = ({
  standalone: isStandalone,
  helpEmail = HELP_EMAIL,
  className,
  ...typographyProps
}: HelpEmailLinkProps): JSX.Element => {
  const t = useTranslations();

  // use different MessageKey based on props
  const emailText: ReactNode = useMemo(() => {
    if (isStandalone) {
      // Need help? Email partnersupport@ouraring.com
      return t.rich('eop_login_email_page_support_text', { helpEmail });
    }
    // Email partnersupport@ouraring.com for assistance.
    return t.rich('eop_need_additional_help_text', { helpEmail });
  }, [helpEmail, isStandalone, t]);

  return (
    <Typography
      data-testid="help-email-link"
      className={cx(className, {
        'flex flex-wrap gap-x-1.5': isStandalone,
      })}
      {...typographyProps}
    >
      {emailText}
    </Typography>
  );
};

export default HelpEmailLink;
